import React, { createRef } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Tabs = function (_React$Component) {
  inherits(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.containerReference = createRef(), _this.state = {
      activeTab: _this.props.initialActiveTab,
      activeTabOffsetLeft: 0
    }, _this.childrenReferences = new Map(), _this.createTab = function (tab) {
      var _this2 = _this,
          _adjustUnderline = _this2.adjustUnderline;
      var activeTab = _this.state.activeTab;
      var customTabClasses = _this.props.customTabClasses;
      var id = tab.props.id;


      var newTabProperties = {
        active: id === activeTab,
        customClasses: customTabClasses,
        adjustUnderline: function adjustUnderline() {
          return _adjustUnderline(id);
        },
        key: 'tab-' + id,
        ref: function ref(reference) {
          return _this.childrenReferences.set(id, reference);
        }
      };

      return React.cloneElement(tab, newTabProperties);
    }, _this.adjustUnderline = function (id) {
      var _this3 = _this,
          containerReference = _this3.containerReference,
          childrenReferences = _this3.childrenReferences;


      var activeTabReference = childrenReferences.get(id).reference.current;
      var activeTabOffsetLeft = activeTabReference.offsetLeft;

      containerReference.current.scrollLeft = activeTabOffsetLeft;
      _this.setState({ activeTabOffsetLeft: activeTabOffsetLeft, activeTab: id });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.adjustUnderline(this.state.activeTab);
    }
  }, {
    key: 'render',
    value: function render() {
      var createTab = this.createTab,
          childrenReferences = this.childrenReferences,
          containerReference = this.containerReference;
      var _state = this.state,
          activeTab = _state.activeTab,
          activeTabOffsetLeft = _state.activeTabOffsetLeft;
      var _props = this.props,
          children = _props.children,
          customClasses = _props.customClasses;
      var customClass = customClasses.customClass,
          customBorder = customClasses.customBorder,
          customUnderline = customClasses.customUnderline,
          customWrapper = customClasses.customWrapper;


      return React.createElement(
        'div',
        { className: customWrapper, ref: containerReference, 'data-test': 'section-tabs' },
        React.createElement(
          'div',
          { className: customClass },
          children.map(createTab),
          React.createElement('span', { className: customBorder }),
          childrenReferences.size > 0 && React.createElement('span', { className: customUnderline,
            style: {
              left: 0,
              transform: 'translateX(' + activeTabOffsetLeft + 'px)',
              width: childrenReferences.get(activeTab).reference.current.offsetWidth
            }
          })
        )
      );
    }
  }]);
  return Tabs;
}(React.Component);

Tabs.propTypes = {
  initialActiveTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customClasses: PropTypes.shape({
    customTabs: PropTypes.string,
    customWrapper: PropTypes.string,
    customBorder: PropTypes.string,
    customUnderline: PropTypes.string
  }),
  customTabClasses: PropTypes.shape({
    customClass: PropTypes.string,
    customActiveClass: PropTypes.string
  }),
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

Tabs.defaultProps = {
  customClasses: {
    customTabs: '',
    customBorder: '',
    customUnderline: '',
    customWrapper: ''
  },
  customTabClasses: {
    customClass: '',
    customActiveClass: ''
  }
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
})();
});

var Tab = function (_React$Component) {
  inherits(Tab, _React$Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.reference = React.createRef(), _this.onClick = function () {
      var _this$props = _this.props,
          active = _this$props.active,
          onClick = _this$props.onClick,
          adjustUnderline = _this$props.adjustUnderline;


      if (!active) {
        onClick();
        adjustUnderline();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tab, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var reference = this.reference,
          onClick = this.onClick;
      var _props = this.props,
          id = _props.id,
          children = _props.children,
          active = _props.active,
          customClasses = _props.customClasses;
      var customClass = customClasses.customClass,
          customActiveClass = customClasses.customActiveClass;


      var classes = classnames((_classNames = {}, defineProperty(_classNames, customClass, true), defineProperty(_classNames, customActiveClass, active), _classNames));

      return React.createElement(
        'button',
        { type: 'button',
          className: classes,
          'data-test': 'button-tab-' + id,
          'aria-selected': active,
          ref: reference,
          onClick: onClick
        },
        children
      );
    }
  }]);
  return Tab;
}(React.Component);

Tab.propTypes = {
  active: PropTypes.bool,
  customClasses: PropTypes.shape({
    customClass: PropTypes.string,
    customActiveClass: PropTypes.string
  }),
  onClick: PropTypes.func,
  adjustUnderline: PropTypes.func,
  children: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

Tab.defaultProps = {
  onClick: function onClick() {},
  adjustUnderline: function adjustUnderline() {},
  active: false,
  customClasses: {
    customClass: '',
    customActiveClass: ''
  }
};

export { Tab, Tabs };
//# sourceMappingURL=index.es.js.map
